<template>
    <div class="autosuggest-container" style="margin-top: 10px;">
    <autocomplete
        input-class="form-control"
        :source="source"
        placeholder="Suchen"
        results-property="data"
        :disableInput="isDisabled"
        :results-display="formattedDisplay"
        @selected="select" v-if="selected === null">
    </autocomplete>
    <div v-else>
      {{ selected.name }} ({{ selected.key }}) <span class="glyphicon glyphicon-remove" @click="clear()" aria-hidden="true"></span>
    </div>
  </div>
</template>
<script>
  import ItemTemplate from './TypeaheadItemTemplate.vue'
  import Autocomplete from 'vuejs-auto-complete'
  import 'v-autocomplete/dist/v-autocomplete.css'
  import { mapState } from 'vuex'
  import calculate from '@mixins/calculate'
  // import { myVar, Settings } from './../config.js'

  export default {
    components: {
      Autocomplete
    },
    mixins: [calculate],
    props: {
      programItems: {
          type: String,
          required: false
      },
      moduleKey: {
        type: String,
        required: true
      },
      areaKey: {
        type: String,
        required: true
      },
      isDisabled: {
        type: Boolean,
        required: false,
        default: false
      }
    },
    data () {
      return {
        uid: null,
        items: [],
        selected: null,
        itemTemplate: ItemTemplate
      }
    },
    computed: {
      ...mapState(['form']),

      source () {
        const self = this
        let keyList = []
        let result = []

        const selected = this.$store.getters.selected.map((item) => {
          return item.key
        })

        let programList = self.$store.getters['programLists']
        // let programItems = self.$store.getters['programItems']
        let programItemsSelected = self.$store.getters['programItemsSelected']
          let moduleGroupsItems = []

          if (typeof programItemsSelected[this.areaKey] !== "undefined") {
              moduleGroupsItems = programList[programItemsSelected[this.areaKey]]
          }

        if (moduleGroupsItems) {
            let moduleItems = []
            moduleGroupsItems.forEach(function (itemValues) {
              let currentModule = self.$store.getters.getModuleById(itemValues)
              moduleItems.push(currentModule)
            });
            moduleItems.forEach((item) => {
              if (item && selected.indexOf(item.key) === -1 && keyList.indexOf((item.key) === -1)) {
                  result.push(item)
                  keyList.push(item.key)
              }
            })
        } else {
            const modules = self.$store.getters['modules']
            modules.forEach((item) => {
                if (selected.indexOf(item.key) === -1 && keyList.indexOf((item.key) === -1)) {
                    result.push(item)
                    keyList.push(item.key)
                }
            })
        }
// console.dir(result)
        return result
      }
    },
    mounted () {
      this.uid = this._uid
      this.items = this.source
    },
    methods: {
        getModule() {
            return this.$store.getters['getModuleById']
        },
        moduleContent (key) {
            return this.getModule(key)
        },
      inArray: function(needle, haystack) {
        var length = haystack.length;
        for(var i = 0; i < length; i++) {
            if(haystack[i] == needle) return true;
        }

        return false;
      },
      select (obj) {
        this.selected = obj.selectedObject
        this.onSelect(obj.selectedObject)
      },
      formattedDisplay (result) {
        return result.name + ' (' + result.key + ')'
      },
      clear () {
        const self = this
        const form = Object.assign({}, self.form)

        let moduleIndex = form.allModules.findIndex((module) => {
          return module.id === self.moduleKey
        })

        if (moduleIndex > -1) {
          form.allModules[moduleIndex].key = self.areaKey
          form.allModules[moduleIndex].label = self.areaKey
          form.allModules[moduleIndex].selected = false
        }
        self.calculateForm(form).then((form) => {
          self.$store.dispatch('setForm', form)
        })
        self.selected = null
      },
      onSelect (payload) {
        const self = this
        const form = Object.assign({}, self.form)

        let moduleIndex = form.allModules.findIndex((module) => {
          return module.id === self.moduleKey
        })

        if (moduleIndex > -1) {
          if (payload) {
            form.allModules[moduleIndex].key = payload.key
            form.allModules[moduleIndex].label = payload.key
            form.allModules[moduleIndex].selected = true
          }
          else {
            form.allModules[moduleIndex].key = self.areaKey
            form.allModules[moduleIndex].label = self.areaKey
            form.allModules[moduleIndex].selected = false
          }
        }
        self.calculateForm(form).then((form) => {
          self.$store.dispatch('setForm', form)
        })
      },
      getLabel (item) {
        if (item) {
          return item.name + ' (' + item.key + ')'
        }
        return ''
      },
      update (text) {
        if (text.length < 3) {
          this.clear()
        }
        this.items = this.source.filter((item) => {
          return (new RegExp(text.toLowerCase())).test(item.name.toLowerCase()) || (new RegExp(text.toLowerCase())).test(item.key.toLowerCase())
        })
        if (this.items.length === 0) {
          this.clear()
        }
      },
      itemSelected (item) {
        this.onSelect(item)
      },
      itemClicked (item) {
        this.onSelect(item)
      }
    },
    watch: {
      query () {
      // query (newVal) {
// console.log(newVal)
        this.onSelect(this.item)
      }
    }
  }
</script>
